"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import type { ComponentProps, FC } from "react";

type Props = {
  icon: ComponentProps<typeof HugeiconsIcon>["icon"];
  color?: string;
  size?: number;
};

const ControlIcon: FC<Props> = ({
  icon,
  color = "currentColor",
  size = 12,
}) => <HugeiconsIcon icon={icon} size={size} color={color} strokeWidth={1.5} />;

export default ControlIcon;
